<template>
  <v-container>
    <v-combobox v-model="selectedValue" :items="items" item-text="Especialidad" item-value="IdEsp"
      label="Selecciona una especialidad médica" clearable dense outlined hide-selected return-object single-line
      persistent-hint width="100%" color="primary" background-color="white" elevation="1" @change="emitValue" />
  </v-container>
</template>

<script>

export default {
  name: "selectEspecialidades",
  data() {
    return {
      selectedValue: '',
      items: []
    };
  },
  mounted() {
    this.getEspecialidades()
  },
  methods: {
    emitValue(value) {
      if (value.Id) {
        this.$emit("value-changed", value?.Id);
      }
    },
    getEspecialidades() {
      this.$http.get(`especialidad`)
        .then(response => {
          if (response.status === 200) {
            this.items = response.data
          }
        })
        .catch(() => {
        });
    },
  },
};
</script>
